import React, {Component} from 'react';
import {connect} from 'react-redux'
import {bindActionCreators} from 'redux'
import {Container} from 'reactstrap';
import {getCmsData} from '../../actions/cmsActions'
import SatisfactionClient from '../../components/SatisfactionClient'
import ContactsNous from '../../components/ContactsNous'
import Events from '../events/Events'

class CmsPage extends Component {
  componentDidMount() {
    let {getCmsData} = this.props
    getCmsData(this.props.match.params.id);
  }

  componentDidUpdate() {
    let {fetching, data} = this.props.cms
    let {getCmsData} = this.props

    if (!fetching) {
      if (parseInt(this.props.match.params.id, 10) !== parseInt(data.id, 10)) {
        getCmsData(this.props.match.params.id);
      }
    }

    window.scrollTo(0, 0)
  }

  render() {
    let {fetching, data} = this.props.cms

    return (
      <div>
        <Container className="container-page">
          {fetching ?
            null
            :
            <section>
              {data.content[0].value ?
                <article>
                <p dangerouslySetInnerHTML={{__html: data.content[0].value}} />
              </article>
              :
              <h2 className="tile-page mb-4" data-aos="fade-up"><strong>{data.meta_title[0].value}</strong></h2>
              }
              {data.id === 1 ?<Events />:null}
              {data.id === 9 ?<ContactsNous />:null}
              {data.id === 7 ?<SatisfactionClient />:null}

             
              
            </section>
          }
        </Container>
      </div>
    )
  }
}

function mapStateToProps({cmsReducer}) {
  return {
    cms: cmsReducer.page,
  }
}
function mapDispatchToProps(dispatch) {
  return {
    getCmsData: bindActionCreators(getCmsData, dispatch),
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(CmsPage);


// WEBPACK FOOTER //
// ./src/components/cms/CmsPage.js